import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bf715f5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row q-col-gutter-lg" }
const _hoisted_2 = { id: "circularProgressContainer" }
const _hoisted_3 = {
  class: "col-xs-8",
  id: "pageTitleContainer"
}
const _hoisted_4 = {
  class: "text-h4 text-weight-bold",
  id: "pageTitle"
}
const _hoisted_5 = {
  key: 0,
  class: "q-py-xs",
  id: "pageDescription"
}
const _hoisted_6 = {
  key: 0,
  class: "q-gutter-xs",
  id: "pageContent"
}
const _hoisted_7 = {
  class: "self-center full-width no-outline",
  id: "pageFieldValue"
}
const _hoisted_8 = {
  class: "self-center full-width no-outline",
  id: "pageFieldValue"
}
const _hoisted_9 = { class: "date-value" }
const _hoisted_10 = { class: "local-time" }
const _hoisted_11 = {
  class: "self-center full-width no-outline",
  id: "pageFieldValue"
}
const _hoisted_12 = { class: "date-value" }
const _hoisted_13 = { class: "local-time" }
const _hoisted_14 = {
  class: "self-center full-width no-outline",
  id: "pageFieldValue"
}
const _hoisted_15 = {
  class: "self-center full-width no-outline",
  id: "pageFieldValue"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CircularProgress = _resolveComponent("CircularProgress")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_field = _resolveComponent("q-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_CircularProgress)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.title)), 1),
        (_ctx.description)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t(_ctx.description)), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_q_separator, {
      class: "q-my-md",
      id: "separator"
    }),
    (_ctx.visitDetails)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_ctx.visitDetails.locationName)
            ? (_openBlock(), _createBlock(_component_q_field, {
                key: 0,
                label: _ctx.$t('portal_visitLocation'),
                "stack-label": "",
                borderless: "",
                id: "pageField"
              }, {
                control: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.visitDetails.locationName), 1)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.visitDetails.entryDateLocal)
            ? (_openBlock(), _createBlock(_component_q_field, {
                key: 1,
                label: _ctx.$t('portal_entryDate'),
                "stack-label": "",
                borderless: "",
                id: "pageField"
              }, {
                control: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.portal.getFormattedDate(_ctx.visitDetails.entryDateLocal)), 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(' ('+ _ctx.$t('portal_localTime') + ')'), 1)
                  ])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.visitDetails.exitDateLocal)
            ? (_openBlock(), _createBlock(_component_q_field, {
                key: 2,
                label: _ctx.$t('portal_exitDate'),
                "stack-label": "",
                borderless: "",
                id: "pageField"
              }, {
                control: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.portal.getFormattedDate(_ctx.visitDetails.exitDateLocal)), 1),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(' ('+ _ctx.$t('portal_localTime') + ')'), 1)
                  ])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.visitDetails.escortName)
            ? (_openBlock(), _createBlock(_component_q_field, {
                key: 3,
                label: _ctx.$t('portal_escort'),
                "stack-label": "",
                borderless: "",
                id: "pageFieldValue"
              }, {
                control: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.visitDetails.escortName), 1)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          (_ctx.visitDetails.notes)
            ? (_openBlock(), _createBlock(_component_q_field, {
                key: 4,
                label: _ctx.$t('portal_notes'),
                "stack-label": "",
                borderless: "",
                id: "pageField"
              }, {
                control: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.visitDetails.notes), 1)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}